import { observable, action } from "mobx";
import config from "../config";
import Http from "axios";

class ProductStore {
  @observable
  products = { docs: [], page: 0, pages: 0, total: 0 };
  @observable
  searchedProducts = [];
  @observable
  page = 0;
  @observable
  searching = false;
  @observable
  category = false;
  @observable
  selectedProduct = {};
  @observable
  featuredProducts = [];
  @observable
  categories = [];
  @observable
  brands = [];

  @action
  setSearchProducts = (products, query) => {
    this.searching = !!query;
    this.searchedProducts = products;
  };

  @action resetSelectedProduct = () => {
    this.selectedProduct = {};
  };

  @action
  setProductsPage = async (sort, page, reset, category, companies) => {
    if (
      ((this.products.pages > 0 &&
        (page ? page : this.page) === this.products.pages) ||
        this.page !== this.products.page) &&
      !reset
    ) {
      return;
    }

    this.page = page ? page : this.page + 1;
    const products = await Http.post(config.api + "/products", {
      page: this.page,
      sort,
      ...(category ? { category } : {}),
      ...(companies ? { companies } : {})
    });

    this.category = category;

    this.products = reset
      ? products.data.result
      : {
          ...products.data.result,
          docs: [...this.products.docs, ...products.data.result.docs]
        };
  };

  @action
  getBrands = async () => {
    const brands = await Http.get(config.api + "/brands");

    this.brands = brands.data.result;
  };

  @action
  getProducts = async (category, brands) => {
    const products = await Http.post(config.api + "/products", {
      ...(category
        ? {
            category
          }
        : {}),
      ...(brands
        ? {
            companies: brands
          }
        : {})
    });
    console.log(products);
    this.page = 1;
    this.products = {
      ...products.data.result,
      docs: products.data.result.docs
    };
  };

  @action
  getCategories = async () => {
    const categories = await Http.get(config.api + "/categories");
    this.categories = categories.data.result.reduce((categories, category) => {
      console.log(category.parentCategory);
      const subCategory = category.parentCategory
        ? categories.reduce((isSubcategory, parentCategory, key) => {
            console.log(parentCategory.subCategories);
            return isSubcategory
              ? isSubcategory
              : parentCategory.subCategories.indexOf(category._id) > -1
              ? { ...parentCategory, key }
              : isSubcategory;
          }, false)
        : false;
      return subCategory
        ? [
            ...categories.slice(0, subCategory.key + 1),
            category,
            ...categories.slice(subCategory.key + 1)
          ]
        : [...categories, category];
    }, []);
  };

  @action
  getProduct(productId) {
    Http.get(config.api + "/products/" + productId)
      .then(product => {
        this.selectedProduct = product.data.result;
        console.log(product.data.result);
      })
      .catch(err => console.error(err));
  }

  @action
  getFeaturedProducts() {
    Http.get(config.api + "/products/featured")
      .then(products => {
        this.featuredProducts = products.data.result;
      })
      .catch(err => console.error(err));
  }
}

const Products = new ProductStore();

export default Products;



// WEBPACK FOOTER //
// ./src/stores/ProductsStore.js